import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "ui-page" }
const _hoisted_2 = { class: "titlebar" }
const _hoisted_3 = { class: "titlebar-content" }
const _hoisted_4 = { class: "titlebar-title --mobile" }
const _hoisted_5 = {
  key: 0,
  class: "titlebar-text"
}
const _hoisted_6 = {
  key: 1,
  class: "titlebar-text"
}
const _hoisted_7 = { class: "titlebar-actions" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "titlebar-actions-secondary" }, null, -1)
const _hoisted_9 = { class: "titlebar-actions-primary" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Salvar")
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "ui-card" }
const _hoisted_13 = { class: "ui-card-body" }
const _hoisted_14 = { class: "ant-row" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_24 = { class: "ant-row" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_26 = { class: "ant-row" }
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Cadastrar")
], -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { class: "ant-row" }
const _hoisted_31 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_32 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_33 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_34 = { class: "ant-row" }
const _hoisted_35 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_36 = { class: "ant-row" }
const _hoisted_37 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_38 = { class: "ant-row" }
const _hoisted_39 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_40 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_41 = { class: "ant-row" }
const _hoisted_42 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_43 = { class: "ant-row" }
const _hoisted_44 = { class: "ant-col ant-col-xs-24 ant-col-xl-14" }
const _hoisted_45 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_46 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Adicionar")
], -1)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = { class: "ant-col ant-col-xs-24 ant-col-xl-11" }
const _hoisted_50 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_51 = ["onUpdate:modelValue"]
const _hoisted_52 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_53 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = { class: "ui-button-content" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Voltar")
], -1)
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Concluir cadastro")
], -1)
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = { class: "ant-row" }
const _hoisted_61 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_62 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-5"
}
const _hoisted_63 = {
  key: 1,
  class: "ant-col ant-col-xs-24 ant-col-xl-5"
}
const _hoisted_64 = { class: "ant-col ant-col-xs-24 ant-col-xl-15" }
const _hoisted_65 = { class: "ant-row" }
const _hoisted_66 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_67 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_combo_area = _resolveComponent("combo-area")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_combo_area_box = _resolveComponent("combo-area-box")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_combo_forma_pagamento = _resolveComponent("combo-forma-pagamento")!
  const _component_combo_status_reserva = _resolveComponent("combo-status-reserva")!
  const _component_combo_cliente = _resolveComponent("combo-cliente")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_editor_html = _resolveComponent("editor-html")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_combo_equipamento = _resolveComponent("combo-equipamento")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_combo_tipo_pessoa = _resolveComponent("combo-tipo-pessoa")!
  const _component_campo_cpf = _resolveComponent("campo-cpf")!
  const _component_campo_cnpj = _resolveComponent("campo-cnpj")!
  const _component_campo_email = _resolveComponent("campo-email")!
  const _component_campo_telefone = _resolveComponent("campo-telefone")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_comunicacao_api = _resolveComponent("comunicacao-api")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.state.reserva.codigo > 0)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_5, "Reserva: " + _toDisplayString(_ctx.state.reserva.numeroIdentificacao), 1))
            : (_openBlock(), _createElementBlock("h2", _hoisted_6, _toDisplayString(_ctx.appBase.titulo), 1))
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("button", {
            class: "ui-button -primary",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.salvar()))
          }, _hoisted_11, 512), [
            [_vShow, (_ctx.state.reserva.codigoBox > 0)]
          ])
        ])
      ])
    ]),
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.appBase.carregando
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_a_form_item, { label: "Área" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_area, {
                          codigo: _ctx.state.reserva.codigoArea,
                          "onUpdate:codigo": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.reserva.codigoArea) = $event)),
                          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.obterArea()))
                        }, null, 8, ["codigo"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_a_form_item, { label: "Data Check-In" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_data, {
                          dataSelecionada: _ctx.state.reserva.dataCheckIn,
                          "onUpdate:dataSelecionada": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.reserva.dataCheckIn) = $event)),
                          onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.consultarDisponibilidadeBoxSelecionado('DataCheckIn'))),
                          disabled: (_ctx.state.reserva.codigoArea === 0)
                        }, null, 8, ["dataSelecionada", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_a_form_item, { label: "Data Check-Out" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_data, {
                          dataSelecionada: _ctx.state.reserva.dataCheckOut,
                          "onUpdate:dataSelecionada": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.reserva.dataCheckOut) = $event)),
                          onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.consultarDisponibilidadeBoxSelecionado('DataCheckOut'))),
                          disabled: (_ctx.state.reserva.codigoArea === 0)
                        }, null, 8, ["dataSelecionada", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_a_form_item, { label: "Box" }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_component_combo_area_box, {
                          key: 'AREA' + _ctx.state.reserva.codigoArea + 'BOX' + _ctx.state.reserva.codigoBox,
                          codigoArea: _ctx.state.reserva.codigoArea,
                          codigo: _ctx.state.reserva.codigoBox,
                          "onUpdate:codigo": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.reserva.codigoBox) = $event)),
                          onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.consultarDisponibilidadeBoxSelecionado('Box'))),
                          disabled: (_ctx.state.reserva.codigoArea === 0)
                        }, null, 8, ["codigoArea", "codigo", "disabled"]))
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_a_form_item, { label: "Valor Total" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_numerico, {
                          monetario: true,
                          valor: _ctx.state.reserva.valorTotal,
                          "onUpdate:valor": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.reserva.valorTotal) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_a_form_item, { label: "Forma de Pagamento" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_forma_pagamento, {
                          codigo: _ctx.state.reserva.codigoFormaPagamento,
                          "onUpdate:codigo": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.reserva.codigoFormaPagamento) = $event))
                        }, null, 8, ["codigo"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_a_form_item, { label: "Valor Pago" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_numerico, {
                          monetario: true,
                          valor: _ctx.state.reserva.valorPago,
                          "onUpdate:valor": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.reserva.valorPago) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_a_form_item, { label: "Status" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_combo_status_reserva, {
                          valor: _ctx.state.reserva.status,
                          "onUpdate:valor": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.reserva.status) = $event))
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_a_form_item, { label: "Cliente" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", {
                            class: _normalizeClass(_ctx.apresentarBotaoCadastroCliente()? 'ant-col ant-col-xs-24 ant-col-xl-20':'ant-col ant-col-xs-24 ant-col-xl-24')
                          }, [
                            (_openBlock(), _createBlock(_component_combo_cliente, {
                              key: 'CLIE-RESERVA' + _ctx.state.reserva.codigoCliente,
                              codigo: _ctx.state.reserva.codigoCliente,
                              "onUpdate:codigo": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.reserva.codigoCliente) = $event)),
                              novoCadastro: _ctx.state.apresentarCadastroNovoCliente,
                              "onUpdate:novoCadastro": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.apresentarCadastroNovoCliente) = $event)),
                              valorDigitado: _ctx.state.valorDigitadoCliente,
                              "onUpdate:valorDigitado": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.valorDigitadoCliente) = $event))
                            }, null, 8, ["codigo", "novoCadastro", "valorDigitado"]))
                          ], 2),
                          _withDirectives(_createElementVNode("div", _hoisted_27, [
                            _createElementVNode("button", {
                              class: "ui-button -primary ui-mh-32 ui-full",
                              type: "button",
                              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.apresentarCadastroCliente()))
                            }, _hoisted_29)
                          ], 512), [
                            [_vShow, _ctx.apresentarBotaoCadastroCliente()]
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createVNode(_component_a_divider, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Número de Pessoas")
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_a_form_item, { label: "Inteira" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.reserva.qtdePessoasInteira) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.reserva.qtdePessoasInteira]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createVNode(_component_a_form_item, { label: "Meia" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.reserva.qtdePessoasMeia) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.reserva.qtdePessoasMeia]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_a_form_item, { label: "Isenta" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.reserva.qtdePessoasIsenta) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.reserva.qtdePessoasIsenta]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createVNode(_component_a_divider, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Observações Check-In")
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createVNode(_component_editor_html, {
                      value: _ctx.state.reserva.observacoesCheckIn,
                      "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.reserva.observacoesCheckIn) = $event))
                    }, null, 8, ["value"])
                  ])
                ]),
                _createVNode(_component_a_divider, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Observações Check-Out")
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createVNode(_component_editor_html, {
                      value: _ctx.state.reserva.observacoesCheckOut,
                      "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.reserva.observacoesCheckOut) = $event))
                    }, null, 8, ["value"])
                  ])
                ]),
                _createVNode(_component_a_collapse, { accordion: "" }, {
                  default: _withCtx(() => [
                    ((_ctx.state.area.tipoControle === _ctx.ETipoControleArea.ConsumoEnergia))
                      ? (_openBlock(), _createBlock(_component_a_collapse_panel, {
                          key: 0,
                          header: "Consumo de Energia"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_38, [
                              _createElementVNode("div", _hoisted_39, [
                                _createVNode(_component_a_form_item, { label: "Medidor Inicial" }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      class: "ant-input",
                                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.reserva.consumoEnergia.medidorInicial) = $event))
                                    }, null, 512), [
                                      [_vModelText, _ctx.state.reserva.consumoEnergia.medidorInicial]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_40, [
                                _createVNode(_component_a_form_item, { label: "Medidor Final" }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      class: "ant-input",
                                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.reserva.consumoEnergia.medidorFinal) = $event))
                                    }, null, 512), [
                                      [_vModelText, _ctx.state.reserva.consumoEnergia.medidorFinal]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createVNode(_component_a_divider, null, {
                              default: _withCtx(() => [
                                _createTextVNode("Observações Energia")
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("div", _hoisted_42, [
                                _createVNode(_component_editor_html, {
                                  value: _ctx.state.reserva.consumoEnergia.observacoes,
                                  "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.reserva.consumoEnergia.observacoes) = $event))
                                }, null, 8, ["value"])
                              ])
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    ((_ctx.state.area.tipoControle === _ctx.ETipoControleArea.ControleEquipamento))
                      ? (_openBlock(), _createBlock(_component_a_collapse_panel, {
                          key: 1,
                          header: "Controle de Equipamentos"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("div", _hoisted_44, [
                                _createVNode(_component_a_form_item, { label: "Equipamento" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_combo_equipamento, {
                                      codigo: _ctx.state.equipamento.codigoEquipamento,
                                      "onUpdate:codigo": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.state.equipamento.codigoEquipamento) = $event)),
                                      valorSelecionado: _ctx.state.equipamento.valor,
                                      "onUpdate:valorSelecionado": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.equipamento.valor) = $event))
                                    }, null, 8, ["codigo", "valorSelecionado"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_45, [
                                _createVNode(_component_a_form_item, { label: "Valor" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_campo_numerico, {
                                      monetario: true,
                                      valor: _ctx.state.equipamento.valor,
                                      "onUpdate:valor": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.state.equipamento.valor) = $event))
                                    }, null, 8, ["valor"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_46, [
                                _createVNode(_component_a_form_item, { label: " " }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("button", {
                                      class: "ui-button -primary ui-mh-32 ui-full",
                                      type: "button",
                                      onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.adicionarEquipamento()))
                                    }, _hoisted_48)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createVNode(_component_a_divider),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.reserva.equipamentos, (equipamento, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "ant-row"
                              }, [
                                _createElementVNode("div", _hoisted_49, [
                                  _createVNode(_component_a_form_item, { label: "Equipamento" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_combo_equipamento, {
                                        codigo: equipamento.codigoEquipamento,
                                        "onUpdate:codigo": ($event: any) => ((equipamento.codigoEquipamento) = $event)
                                      }, null, 8, ["codigo", "onUpdate:codigo"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _createElementVNode("div", _hoisted_50, [
                                  _createVNode(_component_a_form_item, { label: "Quantidade" }, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "number",
                                        class: "ant-input",
                                        "onUpdate:modelValue": ($event: any) => ((equipamento.quantidade) = $event)
                                      }, null, 8, _hoisted_51), [
                                        [_vModelText, equipamento.quantidade]
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _createElementVNode("div", _hoisted_52, [
                                  _createVNode(_component_a_form_item, { label: "Valor" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_campo_numerico, {
                                        monetario: true,
                                        valor: equipamento.valor,
                                        "onUpdate:valor": ($event: any) => ((equipamento.valor) = $event)
                                      }, null, 8, ["valor", "onUpdate:valor"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _createElementVNode("div", _hoisted_53, [
                                  _createVNode(_component_a_form_item, { label: " " }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("button", {
                                        class: "ui-button ui-mh-32 ui-full",
                                        type: "button",
                                        onClick: ($event: any) => (_ctx.removerEquipamento(index))
                                      }, [
                                        _createElementVNode("div", _hoisted_55, [
                                          _createElementVNode("div", null, [
                                            _createVNode(_component_icone, { nome: "excluir" }),
                                            _createTextVNode(" Remover")
                                          ])
                                        ])
                                      ], 8, _hoisted_54)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ])
                              ]))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_a_modal, {
          keyboard: false,
          centered: "",
          width: 1000,
          title: "Cadastro rápido de Cliente",
          visible: _ctx.state.apresentarModalCadastroCliente,
          "onUpdate:visible": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.state.apresentarModalCadastroCliente) = $event))
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("button", {
                class: "ui-button -second",
                type: "button",
                onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.state.apresentarModalCadastroCliente = false))
              }, _hoisted_57, 512), [
                [_vShow, (_ctx.state.cadastrandoCliente === false)]
              ]),
              _withDirectives(_createElementVNode("button", {
                class: "ui-button -primary",
                type: "button",
                onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.cadastrarNovoCliente()))
              }, _hoisted_59, 512), [
                [_vShow, (_ctx.state.cadastrandoCliente === false)]
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_spin, {
              tip: "Loading...",
              spinning: _ctx.state.cadastrandoCliente
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form, { layout: "vertical" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, [
                        _createVNode(_component_a_form_item, { label: "Tipo Pessoa" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_combo_tipo_pessoa, {
                              valor: _ctx.state.novoCliente.tipoPessoa,
                              "onUpdate:valor": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.state.novoCliente.tipoPessoa) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ]),
                      ((_ctx.state.novoCliente.tipoPessoa === 1))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                            _createVNode(_component_a_form_item, { label: "CPF" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_cpf, {
                                  valor: _ctx.state.novoCliente.cpfCnpj,
                                  "onUpdate:valor": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.state.novoCliente.cpfCnpj) = $event))
                                }, null, 8, ["valor"])
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      ((_ctx.state.novoCliente.tipoPessoa === 2))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                            _createVNode(_component_a_form_item, { label: "CNPJ" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_cnpj, {
                                  valor: _ctx.state.novoCliente.cpfCnpj,
                                  "onUpdate:valor": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.state.novoCliente.cpfCnpj) = $event))
                                }, null, 8, ["valor"])
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_64, [
                        _createVNode(_component_a_form_item, {
                          label: _ctx.state.novoCliente.tipoPessoa === 1?'Nome':'Razão Social'
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.state.novoCliente.nomeRazaoSocial) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.novoCliente.nomeRazaoSocial]
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("div", _hoisted_66, [
                        _createVNode(_component_a_form_item, { label: "E-mail" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_email, {
                              valor: _ctx.state.novoCliente.email,
                              "onUpdate:valor": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.state.novoCliente.email) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_67, [
                        _createVNode(_component_a_form_item, { label: "Telefone" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_campo_telefone, {
                              valor: _ctx.state.novoCliente.telefone,
                              "onUpdate:valor": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.state.novoCliente.telefone) = $event))
                            }, null, 8, ["valor"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["spinning"])
          ]),
          _: 1
        }, 8, ["visible"])
      ]),
      _: 1
    }),
    _createVNode(_component_comunicacao_api, {
      visivel: _ctx.appBase.exibirComunicaoApi,
      "onUpdate:visivel": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.appBase.exibirComunicaoApi) = $event)),
      apresentarBarraProgresso: _ctx.appBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.appBase.fraseBarraProgresso,
      resposta: _ctx.appBase.resposta
    }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "resposta"])
  ]))
}